module.exports = __webpack_public_path__ + "static/media/14.ea626852.svg";